import React, { useEffect, useRef, useState } from 'react';
import { Photographer, Order } from '../BookingsCalendarTypes';

function useMap<T extends any[]>(selectedOrder: Order, photographers: Photographer[]) {
    const mapRef = useRef<HTMLDivElement>(null);
    const [map, setMap] = useState<google.maps.Map | null>(null);
    
    const { apiUrl } = window.appConfig;
    
    const markerList = () => {
        const orderCoordinates = selectedOrder.orderAddress.addressPointLocation;
        const markers = [
            {
                latitude: orderCoordinates.latitude,
                longitude: orderCoordinates.longitude,
                distance: null,
                name: selectedOrder.orderAddress.address,
                url: ''
            }
        ];
        photographers.forEach(photographer => {
            const [latitudeStr, longitudeStr] = photographer.workingHours[0].coordinates.split(',');
    
            markers.push({
                latitude: parseFloat(latitudeStr),
                longitude: parseFloat(longitudeStr),
                distance: (photographer.travelDistance/1000).toFixed(2),
                name: photographer.name,
                url: photographer.profileImageReference
                    ? `${apiUrl}/file/${photographer.profileImageReference}`
                    : 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNTAgMjUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI2Ni40MyAtNDAxLjY1KSI+CiAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoLjY4MzMzIDAgMCAuNjgzMzMgNTgxLjk0IDU1MC43NykiIGZpbGw9IiNEREREREQiPgogICA8cmVjdCB4PSItNDYxLjczIiB5PSItMjE4LjIzIiB3aWR0aD0iMzY1Ljg1IiBoZWlnaHQ9IjM2NS44NSIgcng9IjAiIHJ5PSIwIiBjb2xvcj0iIzAwMDAwMCIgZmlsbD0iI0RERERERCIvPgogIDwvZz4KICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCguMzQ5MiAwIDAgLjM0OTIgMjg0LjU3IDQxOS43OSkiIGZpbGw9IiNGRkYiPgogICA8ZyBmaWxsPSIjRkZGIj4KICAgIDxwYXRoIGQ9Im0zMDYgMzI1Ljk5YzkwLjU2LTAuMDEgMTIzLjE1LTkwLjY4IDEzMS42OC0xNjUuMTcgMTAuNTEtOTEuNzYtMzIuODgtMTYwLjgyLTEzMS42OC0xNjAuODItOTguNzggMC0xNDIuMTkgNjkuMDU1LTEzMS42OCAxNjAuODIgOC41NCA3NC40ODQgNDEuMTE0IDE2NS4xOCAxMzEuNjggMTY1LjE3eiIvPgogICAgPHBhdGggZD0ibTU1MC45OCA1NDEuOTFjLTAuOTktMjguOTA0LTQuMzc3LTU3LjkzOS05LjQyMS04Ni4zOTMtNi4xMTEtMzQuNDY5LTEzLjg4OS04NS4wMDItNDMuOTgzLTEwNy40Ni0xNy40MDQtMTIuOTg4LTM5Ljk0MS0xNy4yNDktNTkuODY1LTI1LjA4MS05LjY5Ny0zLjgxLTE4LjM4NC03LjU5NC0yNi41MzctMTEuOTAxLTI3LjUxOCAzMC4xNzYtNjMuNCA0NS45NjItMTA1LjE5IDQ1Ljk2NC00MS43NzQgMC03Ny42NTItMTUuNzg2LTEwNS4xNy00NS45NjQtOC4xNTMgNC4zMDgtMTYuODQgOC4wOTMtMjYuNTM3IDExLjkwMS0xOS45MjQgNy44MzItNDIuNDYxIDEyLjA5Mi01OS44NjMgMjUuMDgxLTMwLjA5NiAyMi40NjMtMzcuODczIDcyLjk5Ni00My45ODMgMTA3LjQ2LTUuMDQ1IDI4LjQ1NC04LjQzMyA1Ny40ODktOS40MjIgODYuMzkzLTAuNzY2IDIyLjM4NyAxMC4yODggMjUuNTI1IDI5LjAxNyAzMi4yODQgMjMuNDUzIDguNDU4IDQ3LjY2NiAxNC43MzcgNzIuMDQxIDE5Ljg4NCA0Ny4wNzcgOS45NDEgOTUuNjAzIDE3LjU4MiAxNDMuOTIgMTcuOTI0IDQ4LjMxOC0wLjM0MyA5Ni44NDQtNy45ODMgMTQzLjkyLTE3LjkyNCAyNC4zNzUtNS4xNDUgNDguNTktMTEuNDI0IDcyLjA0MS0xOS44ODQgMTguNzM2LTYuNzU3IDI5Ljc4OS05Ljg5NSAyOS4wMjMtMzIuMjg0eiIvPgogICA8L2c+CiAgPC9nPgogPC9nPgo8L3N2Zz4K'
            });
        });
        return markers;
    };
    
    useEffect(() => {
        const zoom = 12;
    
        const center: google.maps.LatLngLiteral = {
            lat: markerList()[0].latitude,
            lng: markerList()[0].longitude,
        };
    
        const mapOptions: google.maps.MapOptions = {
            center,
            streetViewControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoom,
        };
    
        const newMap = new google.maps.Map(mapRef.current!, mapOptions);
        setMap(newMap);
    
    }, []);

    return {
        map,
        markerList,
        mapRef
    };
}

export default useMap;
